<div class="text-button text-button--{{size}}"
    [class.text-button--disabled]="disabled"
>
    {{text}}
</div>
